import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from './data.service';
import { AppconfigService } from './appconfig.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
      
  constructor(private data: DataService, 
              private config: AppconfigService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
    if (this.data.username == this.config.apiUsername && this.data.userpass == this.config.apiPassword) {
      return true;
    }
    else{
      alert('Acesso não autorizado.');
      return false;
    }

  }
  
}
